import { ListContext } from 'components/ListsProvider';
import { useContext } from 'react';
import useLoginStore from 'store/loginStore';

const useLists = () => {
  const { schema, logoUrlPrefix, colors, countries, lists } = useContext(ListContext);
  const isSystemAdmin = useLoginStore(s => s.isSystemAdmin)();

  const events = [
    { entity: 'GameEventSave', name: 'Save', color: '#7c5f0d' },
    { entity: 'GameEventGoal', name: 'Goal', color: '#0a0' },
    { entity: 'GameEventPenalty', name: 'Penalty', color: '#a00' },
    { entity: 'GameEventInjury', name: 'Injury', color: '#a00' },
    { entity: 'GameEventFaceOff', name: 'Face off', color: '#968f66' },
    { entity: 'GameEventPenaltyshot', name: 'Penalty shot', color: '#99371f' },

    // multi events
    { entity: 'MultiGameEventPenalty', name: 'P 2x', color: '#a00', isMulti: true},
    { entity: 'MultiGameEventPenaltyShotGoal', name: 'P + PS + G', color: '#0a0', isMulti: true},
    { entity: 'MultiGameEventPenaltyShot', name: 'P + PS', color: '#99371f', isMulti: true},

  ];

  const userRoles = [
    isSystemAdmin ? { value: 'SYSTEM_ADMIN', label: 'System Admin' } : null,
    { value: 'ADMIN', label: 'Org Admin' }, //opeq: can org admins create other org admins?
    { value: 'TEAM_MANAGER', label: 'Team Manager' },
    { value: 'PLAYER', label: 'Player' },
  ].filter(r => r != null);

  const FILE_SIZE_LIMIT = 25 * 1024 * 1024;

  return { schema, logoUrlPrefix, colors, countries, ...lists, events, userRoles, FILE_SIZE_LIMIT };
}

export default useLists;
